const KEY = "ghostbeats:progress:v1";

interface ProgressState {
  completed: string[];
}

function read(): ProgressState {
  try {
    return JSON.parse(localStorage.getItem(KEY) ?? '{"completed":[]}') as ProgressState;
  } catch {
    return { completed: [] };
  }
}

export function completedModules(): Set<string> {
  return new Set(read().completed);
}

export function markComplete(slug: string): void {
  const state = read();
  if (!state.completed.includes(slug)) state.completed.push(slug);
  localStorage.setItem(KEY, JSON.stringify(state));
}

export function resetProgress(): void {
  localStorage.removeItem(KEY);
}
